import { Directive } from '@angular/core';

@Directive({
  selector: '[floatingLabel]',
  inputs: ['floatingLabel', 'focus'],
  host: {
    '[class.floating-label-form-group-with-value]': '!!floatingLabel',
    '[class.floating-label-form-group-with-focus]': 'focus',
    '[class.floating-label-form-group]': 'true'
  }
})
export class FloatingLabelDirective {
  constructor() {}
}
